module.exports = __webpack_public_path__ + "static/media/OneStepStudyCover(with-tagline).099210d0.png";